import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Gallery = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 16}
      height={size ?? 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.72052 12.6733L1.70719 12.6867C1.52719 12.2933 1.41385 11.8467 1.36719 11.3533C1.41385 11.84 1.54052 12.28 1.72052 12.6733Z"
        fill={color}
      />
      <path
        d="M6.00073 6.92C6.87702 6.92 7.5874 6.20962 7.5874 5.33333C7.5874 4.45704 6.87702 3.74667 6.00073 3.74667C5.12444 3.74667 4.41406 4.45704 4.41406 5.33333C4.41406 6.20962 5.12444 6.92 6.00073 6.92Z"
        fill={color}
      />
      <path
        d="M10.792 1.33333H5.20536C2.7787 1.33333 1.33203 2.78 1.33203 5.20667V10.7933C1.33203 11.52 1.4587 12.1533 1.70536 12.6867C2.2787 13.9533 3.50536 14.6667 5.20536 14.6667H10.792C13.2187 14.6667 14.6654 13.22 14.6654 10.7933V9.26667V5.20667C14.6654 2.78 13.2187 1.33333 10.792 1.33333ZM13.5787 8.33333C13.0587 7.88667 12.2187 7.88667 11.6987 8.33333L8.92536 10.7133C8.40536 11.16 7.56536 11.16 7.04536 10.7133L6.8187 10.5267C6.34536 10.1133 5.59203 10.0733 5.0587 10.4333L2.56536 12.1067C2.4187 11.7333 2.33203 11.3 2.33203 10.7933V5.20667C2.33203 3.32667 3.32536 2.33333 5.20536 2.33333H10.792C12.672 2.33333 13.6654 3.32667 13.6654 5.20667V8.40667L13.5787 8.33333Z"
        fill={color}
      />
    </svg>
  );
});

export default Gallery;
